import { createAsyncThunk } from '@reduxjs/toolkit'
import { doGetEmails } from '../shared/sharedApiThunks'

export const getEmails = createAsyncThunk('NEW_INCIDENT/getEmails', doGetEmails)
export const getMoreEmails = createAsyncThunk('NEW_INCIDENT/getMoreEmails', doGetEmails)
